import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import { useMutation, useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";

const getAllClaims = async ({
  companyCode,
  locationCode,
  employee = 0,
  fromDate,
  toDate,
  isAllCompanies = false,
  userId = 0,
  selectedCompanyCode = "",
  status = 'All'
}) => {
  let queryString = `?isAllCompanies=${isAllCompanies}&companyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&FromDate=${fromDate}&ToDate=${toDate}&LocationCode=${locationCode}`;
  if (employee !== 0) {
    queryString += `&Employee=${employee}`;
  }

  if(status !== "All") {
    queryString += `&Status=${Number(status)}`;
  } else {
    queryString += `&Status=${status}`;
  }

  if (isAllCompanies && userId !== 0) {
    queryString += `&UserId=${userId}`;
  }

  if (companyCode && locationCode) {
    const { data } = await http_payroll.get(
      `${Api_EndPoints.EmpClaimDetails}${queryString}`,
    );

    return data;
  }
  return [];
};

const getClaim = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetClaim}?CompanyCode=${companyCode}&Code=${code}`,
  );
  return data;
};

const insertClaim = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.InsertClaims, input);
  return data;
};

const updateClaim = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.UpdateClaims, input);
  return data;
};

export const useGetClaimsQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.EmpClaimDetails],
    queryFn: () => getAllClaims(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetClaimById = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetClaim],
    queryFn: () => getClaim(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertClaimMutation = () => {
  return useMutation({
    mutationFn: insertClaim,
  });
};

export const useUpdateClaimMutation = () => {
  return useMutation({
    mutationFn: updateClaim,
  });
};
